import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { CatButton } from "assets/styled-components/CatButton";
import useParseAi from "hooks/useParseAi";
import { useEffect } from "react";

export default function SubmitForm({
    formData,
    setTabValue,
    setIsDialogClosed,
}) {
    const {
        submitAiData,
        isSubmitLoading,
        isSubmitSuccess,
        submitErrorMessages,
    } = useParseAi();

    useEffect(() => {
        if (isSubmitSuccess) {
            setIsDialogClosed();
        }
    }, [isSubmitSuccess, setIsDialogClosed, formData.candidateId]);

    const handleAiSubmit = async () => {
        await submitAiData(formData.candidateId, formData);
    };

    return (
        <Stack gap={2} sx={{ mt: 2, mb: 4 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>
                You are almost done!
            </Typography>
            <Typography variant="body2" color="textSecondary">
                If you want to review or edit any section, please navigate back
                using the tabs or by choosing from the list
            </Typography>
            <Stack gap={1}>
                <Typography variant="body1">Sections:</Typography>
                <Stack gap={1} flexWrap="wrap">
                    <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => setTabValue("candidate-information")}
                    >
                        Candidate Information
                    </Typography>
                    <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                        onClick={() =>
                            setTabValue("personal-details-preferences")
                        }
                    >
                        Personal Details & Preferences
                    </Typography>
                    <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => setTabValue("experiences")}
                    >
                        Experiences
                    </Typography>
                    <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer", textDecoration: "underline" }}
                        onClick={() => setTabValue("educations")}
                    >
                        Educations
                    </Typography>
                </Stack>
            </Stack>

            {submitErrorMessages.length > 0 && (
                <Alert severity="error">
                    <AlertTitle>Submit failed</AlertTitle>
                    {submitErrorMessages.length === 1 ? (
                        submitErrorMessages[0]
                    ) : (
                        <Stack component="ul" sx={{ pl: 2, m: 0 }}>
                            {submitErrorMessages.map((message) => (
                                <Typography
                                    key={message}
                                    component="li"
                                    variant="body2"
                                >
                                    {message}
                                </Typography>
                            ))}
                        </Stack>
                    )}
                </Alert>
            )}
            {isSubmitSuccess && (
                <Typography variant="body1" color="success.main">
                    Your application has been submitted successfully!
                </Typography>
            )}
            <CatButton
                variant="contained"
                onClick={handleAiSubmit}
                disabled={isSubmitLoading}
            >
                {isSubmitLoading ? "Submitting..." : "Submit Candidate"}
            </CatButton>
        </Stack>
    );
}
